import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import TemplateRecoverPassword from '../../templates/Login/Recover';

export default function RecoverPassword(props) {
  const { userInfo } = useSelector((state) => state.userSign);

  useEffect(() => {
    if (userInfo) {
      props.history.push('/');
    }
  }, [userInfo, props.history]);

  return <TemplateRecoverPassword />;
}
